export const ONE_MINUTE_STALE_TIME = 60 * 1000;
export const FIVE_MINUTES_STALE_TIME = 5 * ONE_MINUTE_STALE_TIME;
